
import React, { useContext } from 'react';
import { ConfigurationContext } from '../../../shared/context/ConfigurationContext';
import global from '../../../shared/utility/global';

import facebook from '../../../assets/icons/social-networks/facebook.svg';
import instagram from '../../../assets/icons/social-networks/instagram.svg';
import tiktok from '../../../assets/icons/social-networks/tiktok.svg';
import twitter from '../../../assets/icons/social-networks/twitter.svg';
import whatsapp from '../../../assets/icons/social-networks/whatsapp.svg';
import youtube from '../../../assets/icons/social-networks/youtube.svg';

export default function Index(props) {
    const configuration = useContext(ConfigurationContext);

    const whatsappLink = () => {
        const text = encodeURIComponent(`Hola, solicito información sobre sus productos.`);
        const url = `https://wa.me/${configuration.data.company.whatsapp}?text=${text}`;
        window.open(url, '_blank')
    };

    return (
        <div style={{ background: '' }}>
            <div className="container" style={{ marginTop: '100px' }}>

                <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-5 ">
                    <div className="row w-100">
                        <div className="col-md-8 d-flex align-items-center">
                            <span className="text-muted">
                                <i className="bi bi-geo-alt-fill"></i>&nbsp;&nbsp;{configuration.data.company.location}
                            </span>
                        </div>
                        <ul className="nav col-md-4 justify-content-end list-unstyled d-flex">
                            <span className="text-muted">
                                <i className="bi bi-envelope"></i>&nbsp;&nbsp;{configuration.data.company.email}
                            </span>
                        </ul>
                    </div>

                    <div className='border-top w-100 mb-4 mt-4' />

                    <div className="row w-100">
                        <div className="col-md-8 d-flex align-items-center">
                            <a href="/" className="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1">
                                <img src={configuration.data.company.imageUrl} style={{ height: '45px' }} />
                            </a>
                            <span className="text-muted">© {configuration.data.company.businessName}. Todos los derechos reservados {global.fetchCurrentYear()}</span>
                        </div>
                        <ul className="nav col-md-4 justify-content-end list-unstyled d-flex">
                            {
                                configuration.data.company.twitter ?
                                    <li className="ms-3">
                                        <a className="text-muted" href={configuration.data.company.twitter} target='_blank'>
                                            <img src={twitter} style={{ height: '30px' }} />
                                        </a>
                                    </li> : null
                            }
                            {
                                configuration.data.company.youtube ?
                                    <li className="ms-3">
                                        <a className="text-muted" href={configuration.data.company.youtube} target='_blank'>
                                            <img src={youtube} style={{ height: '30px' }} />
                                        </a>
                                    </li> : null
                            }
                            {
                                configuration.data.company.tiktok ?
                                    <li className="ms-3">
                                        <a className="text-muted" href={configuration.data.company.tiktok} target='_blank'>
                                            <img src={tiktok} style={{ height: '30px' }} />
                                        </a>
                                    </li> : null
                            }
                            {
                                configuration.data.company.instagram ?
                                    <li className="ms-3">
                                        <a className="text-muted" href={configuration.data.company.instagram} target='_blank'>
                                            <img src={instagram} style={{ height: '30px' }} />
                                        </a>
                                    </li> : null
                            }
                            {
                                configuration.data.company.facebook ?
                                    <li className="ms-3">
                                        <a className="text-muted" href={configuration.data.company.facebook} target='_blank'>
                                            <img src={facebook} style={{ height: '30px' }} />
                                        </a>
                                    </li> : null
                            }
                            {
                                configuration.data.company.whatsapp ?
                                    <li className="ms-3">
                                        <a className="text-muted" onClick={whatsappLink} style={{ textDecoration: 'none' }}>
                                            <img src={whatsapp} style={{ height: '30px' }} />
                                        </a>
                                    </li> : null
                            }
                        </ul>
                    </div>
                </footer>
            </div>
        </div>
    );
}